// @flow

import styled, { css } from "styled-components";
import { generateTransition, easeInOut } from "../../_static/Transitions";
import { fontNormal, fontMedium, fontBold } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";
import { buildText } from "../../_atom/Text";

export const RunnerInfoContainer = styled.div`
  width: 100%;
`;

export const RunnerInfoHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const RunnerInfoTitle = styled.h3`
  font-family: ${fontBold};
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
`;

export const RunnerInfoShowMoreLink = styled.button`
  margin-left: 8px;
  white-space: nowrap;
  font-family: ${fontMedium};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${buildColor("blue_accent", "500")};
  background-color: transparent;
  outline: none;
  cursor: pointer;
`;

export const RunnerMainInfo = styled(
  buildText({
    tag: "span",
    fontSize: 14,
    color: buildColor("grey", "800")
  })
)`
  font-family: ${fontNormal};
  font-style: normal;
  font-weight: normal;
  line-height: 18px;
`;

export const RunnerFlagsContainer = styled.div`
  margin-top: 12px;
`;

export const RunnerComplementaryInfo = styled.div`
  transition: ${generateTransition(easeInOut, "max-height")};
  ${({ isVisible }) =>
    isVisible
      ? css`
          max-height: 300px;
        `
      : css`
          max-height: 0;
          overflow: hidden;
        `}

  &::before {
    visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
    margin: ${({ smallPadding }) =>
      smallPadding ? "12px -12px 8px 0" : "12px -12px 12px 0"};
    content: " ";
    display: block;
    border-bottom: 1px solid ${buildColor("blue", "100")};
  }
`;

export const ComplementaryInfo = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ComplementaryInfoLabel = styled(
  buildText({
    tag: "span",
    fontSize: 14,
    color: buildColor("grey", "900"),
    capitalize: true
  })
)`
  display: inline-block;
  width: 55px;
  font-family: ${fontMedium};
  font-weight: 500;
  line-height: 19px;
  vertical-align: top;
`;

export const ComplementaryInfoValue = styled(
  buildText({
    tag: "span",
    fontSize: 14,
    color: buildColor("grey", "800"),
    capitalize: true
  })
)`
  max-width: calc(100% - 76px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: ${fontNormal};
  line-height: 18px;
  vertical-align: top;
  ${({ hasChanges }) =>
    hasChanges
      ? css`
          margin-left: 8px;
          font-family: ${fontMedium};
          font-weight: 500;
          line-height: 19px;
          color: ${buildColor("orange", "800")};
        `
      : css`
          margin-left: 19px;
          font-family: ${fontNormal};
          font-weight: normal;
          line-height: 18px;
        `};
`;

export const IconContainer = styled.div`
  display: inline-block;
  height: 12px;
  width: 12px;
  border: 1.5px solid ${buildColor("grey", "900")};
  border-radius: 1px;
  transform: rotate(45deg);

  .icon-transformation {
    position: absolute;
    top: -36%;
    left: -36%;
    transform: rotate(-45deg);
  }
`;
